import React, { Component } from 'react';
import FD from '../../../RestAPI/fetchData';
import App_data from '../../../config/App_data';
import language from '../../../../assets/languages/language';
import Loader from '../../../../common/loader';
import { Button } from 'reactstrap';
import Slider from 'react-slick';
import { questionsettings } from '../../../../common/cbtleftnavigationsettings';
import { frmOptionsArr, SecondsToHHMMSS } from '../../../../common/constant';
import AppRoutes from '../../../config/AppRoutes';
import { renderHTMLContent } from '../../../../common/function';
/* eslint-disable*/

class CFAQuestions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      questionsData: [],
      totalCount: 0,
      isLoading: true,
      isDataLoading: true,
      token: '',
      idname: '',
      userStatsData: '',
      reportLoading: false,
      time: {},
      seconds: 100,
      showFinishTestPopup: false,
      showAnswer: false,
      rightanswercount: '',
      text: '',
      mockName: '',
      showSectionReview: false,
      readingViseScore: [],
      selectedQuestionData: [],
      successAlert: false,
      report_block: 'card hide_block',
    };
    this.timer = 0;
    // this.countDown = this.countDown.bind(this);
  }
  //it is use to redirect page
  static contextTypes = {
    router: React.PropTypes.object,
  };

  getQuestions = data => {
    this.setState({
      isDataLoading: true,
    });
    FD.callAPI(App_data.backend_api + '/frmCBTMockExams/getFRMMockQuestions', data).then(resp => {
      if (resp.success) {
        this.setState({
          questionsData: resp.question,
          totalCount: resp.question.length,
          selectedQuestionData: resp.question[this.props.params.offset],
          isLoading: false,
          isDataLoading: false,
        });
      } else {
        this.setState({
          isLoading: false,
          isDataLoading: false,
        });
      }
    });
  };

  getUserStats = () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      level: this.props.params.level ? parseInt(this.props.params.level) : null,
      id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
    };
    FD.callAPI(App_data.backend_api + '/frmCBTMockExams/getUsersStats', data).then(resp => {
      if (resp.success) {
        this.setState({
          userStatsData: resp.data,
        });
      } else {
        this.setState({
          isLoading: false,
        });
      }
    });
  };

  componentDidMount = () => {
    window.scrollTo(0, 0);
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      token: storage_session['token'],
      idname: storage_session['idname'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      level: this.props.params.level ? parseInt(this.props.params.level) : null,
    };
    this.getQuestions(data);
    this.getUserStats();
    this.getFlagQuestions();
    this.timer = setInterval(this.countDown, 1000);
    const ansdata = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      level: this.props.params.level ? parseInt(this.props.params.level) : null,
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
    };
    //Api to fetch all right answered on particular quiz id
    FD.callAPI(App_data.backend_api + '/frmCBTMockExams/getrightAnswer', ansdata).then(
      resp_count => {
        if (resp_count.success) {
          this.setState({
            rightanswercount: resp_count.allrightanswercount.question_count,
          });
        } else {
          console.log(resp_count.success + '------------failure');
        }
      },
    );

    FD.callAPI(App_data.backend_api + '/frmCBTMockExams/getMockNamebyId', data).then(async res => {
      this.setState({
        mockName: res.mockdata && res.mockdata.mock_exam ? res.mockdata.mock_exam : '',
      });
    });
  };

  changeQuestion = (questionNumber, index) => {
    this.setState({ report_block: 'card hide_block', successAlert: false });
    this.getUserStats();
    if (questionNumber) {
      this.context.router.push({
        pathname: `/frm/cbtquestionsfinish/${this.props.params.id}/${questionNumber}/${this.props.params.timer
          }/${this.props.params.level}/${this.props.params.testid}/${index}`,
      });
    }
  };

  getPrevious = index => {
    this.setState({ report_block: 'card hide_block', successAlert: false });
    this.slider.slickGoTo(index - 2);
    const { questionsData } = this.state;
    this.context.router.push({
      pathname: `/frm/cbtquestionsfinish/${this.props.params.id}/${this.props.params.offset ? questionsData[parseInt(this.props.params.offset) - 1].id : 1
        }/${this.props.params.timer}/${this.props.params.level}/${this.props.params.testid}/${this.props.params.offset ? parseInt(this.props.params.offset) - 1 : 1
        }`,
    });
  };

  getNext = async index => {
    this.setState({ report_block: 'card hide_block', successAlert: false });
    this.slider.slickGoTo(index);
    const { questionsData } = this.state;
    this.context.router.push({
      pathname: `/frm/cbtquestionsfinish/${this.props.params.id}/${this.props.params.offset ? questionsData[parseInt(this.props.params.offset) + 1].id : 1
        }/${this.props.params.timer}/${this.props.params.level}/${this.props.params.testid}/${this.props.params.offset ? parseInt(this.props.params.offset) + 1 : 1
        }`,
    });
  };

  backToMock = () => {
    this.context.router.push({
      pathname: `/frm/viewattemptedmock/${this.props.params.id}/${this.props.params.timer}/${this.props.params.level
        }`,
    });
  };
  getDetailedResultGraph = totalQuestion => {
    const { id, testid, level, timer } = this.props.params;
    let path = AppRoutes.FRM_DETAILED_RESULT_GRAPH.replace(':id', id)
      .replace(':test_id', testid)
      .replace(':totalQuestions', totalQuestion)
      .replace(':level', level)
      .replace(':timer', timer);
    this.context.router.push({
      pathname: path,
    });
  };
  getReadingViseScore = () => {
    const data = {
      token: this.state.token,
      idname: this.state.idname,
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
      level: this.props.params.level ? parseInt(this.props.params.level) : null,
    };
    FD.callAPI(App_data.backend_api + '/frmCBTMockExams/getrightAnswerReadingVise', data).then(
      async res => {
        let temp = 0;
        let arr = res.readingName.map((item, i) => {
          if (res.allrightanswercount.some(ele => ele.id === item.id)) {
            return Object.assign({}, item, res.allrightanswercount[temp++]);
          } else return Object.assign({}, item, 0);
        });
        this.setState({
          readingViseScore: arr,
        });
      },
    );
  };

  getFlagQuestions = () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    const data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
      level: this.props.params.level ? parseInt(this.props.params.level) : null,
    };
    FD.callAPI(App_data.backend_api + '/frmCBTMockExams/getflaggedQuestions', data).then(
      async res => {
        if (res) {
          this.setState({ flag: res.data });
        }
      },
    );
  };

  componentDidUpdate = prevProps => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    if (prevProps.params.offset !== this.props.params.offset) {
      var data = {
        token: storage_session['token'],
        idname: storage_session['idname'],
        mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
        level: this.props.params.level ? parseInt(this.props.params.level) : null,
      };
      this.getQuestions(data);
    }
  };

  reportQuestion = id => {
    var comment = document.getElementById('comment').value;
    // console.log("function calling...", comment.length);

    if (comment.length < 2) {
      return;
    }
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: id,
      comment: comment,
      level: this.props.params.level ? parseInt(this.props.params.level) : null,
      offset: this.props.params.offset ? parseInt(this.props.params.offset) : 0,
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : 0,
      timer: this.props.params.timer ? parseInt(this.props.params.timer) : 0,
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : 0,
      mockName: this.state.mockName,
    };

    this.setState({
      reportLoading: true,
    });
    FD.callAPI(App_data.backend_api + '/frmCBTMockExams/reportQuestion', data).then(resp => {
      if (resp.success) {
        this.setState({
          ValidToken: true,
          successAlert: true,
          reportLoading: false,
        });
        document.getElementById('comment').value = '';
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });
  };

  //Function to hide Report box
  _hideReportForm = (item, e) => {
    document.getElementById('comment').value = '';
    this.setState({ report_block: 'card hide_block' });
  };

  //Function to show Report box
  _displayReportForm = (item, e) => {
    this.setState({ report_block: 'card show_block' });
  };

  onClose = e => {
    this.setState({
      report_block: 'card hide_block',
      successAlert: false,
    });
  };

  handleScroll = () => {
    window.scroll({
      top: document.body.offsetHeight,
      left: 0,
      behavior: 'smooth',
    });
  };

  render() {
    const {
      isLoading,
      questionsData,
      userStatsData,
      rightanswercount,
      mockName,
      showSectionReview,
      readingViseScore,
      selectedQuestionData,
      isDataLoading,
      flag,
      reportLoading,
    } = this.state;
    const { question_ids } = userStatsData;
    const totalAvailableQuestions =
      (question_ids && JSON.parse(question_ids).length) ||
      (questionsData && questionsData.length) || 0;
    let userChoice =
      userStatsData && userStatsData.questions ? JSON.parse(userStatsData.questions) : '';
    let userTime = 0;
    if (userStatsData && userStatsData.user_time_value && this.props.params.timer) {
      if (userStatsData.isNegative === 'true') {
        userTime = SecondsToHHMMSS(
          parseInt(this.props.params.timer) - userStatsData.user_time_value,
        );
      } else {
        userTime = SecondsToHHMMSS(
          parseInt(this.props.params.timer) + userStatsData.user_time_value,
        );
      }
    }
    let percentage = (rightanswercount * 100) / totalAvailableQuestions;
    const sliderSettings = questionsettings(
      this.props.params.offset ? parseInt(this.props.params.offset) : 1,
    );
    return (
      <div>
        <div className='animated fadeIn'>
          <div className='margin_bottom_20 ques-title-wrapper'>
            <h1 className='section_head'> {mockName}</h1>
            <div className='finish-btn-wrapper'>
              <Button
                className='pointer_class btn-primary back-btn'
                onClick={() => this.backToMock()}
              >
                {language.LC().BACK}
              </Button>
            </div>
          </div>
          {isLoading ? (
            <Loader />
          ) : questionsData && questionsData.length ? (
            <div>
              <div className='row margin_bottom_20'>
                <div className='qus-tab-wrapper'>
                  <Slider
                    {...sliderSettings}
                    ref={slider => {
                      this.slider = slider;
                    }}
                  >
                    {' '}
                    {questionsData.map((item, index) => {
                      let flaggedQuestions =
                        flag && flag.length
                          ? flag.filter(flag => flag.question_id === item.id)[0]
                          : '';
                      return (
                        <div className='slide-button' key={index}>
                          <Button
                            onClick={() => this.changeQuestion(item.id, index)}
                            className={`
                        ${index === parseInt(this.props.params.offset) ? 'active' : ''}
                        ${userChoice[item.id] === item.answer
                                ? 'right-ans'
                                : userChoice[item.id]
                                  ? 'wrong-ans'
                                  : 'not-ans'
                              }
                        ${flaggedQuestions ? 'flag-add' : ''}
                        `}
                          >
                            {flaggedQuestions ? (
                              <img
                                width='70'
                                src={App_data.frontend_url + '/img/questions/icon_flag_white.png'}
                                alt='Question'
                              />
                            ) : (
                              ''
                            )}
                            {index + 1}
                          </Button>
                        </div>
                      );
                    })}
                  </Slider>
                </div>
                <div className='ques-detail-wrapper col-md-12'>
                  {isDataLoading ? (
                    <Loader />
                  ) : (
                    <div className='card'>
                      <div className='card-header qus-header finish-question-wrapper'>
                        {selectedQuestionData && selectedQuestionData.question ? (
                          <div className='qus-wrapper ques-bold-remove d-block'>
                            <div>
                              <img
                                src={
                                  App_data.frontend_url +
                                  '/img/question_bank/question_icon_blue.svg'
                                }
                                className='margin_right_20'
                                alt=''
                                width='30'
                              />
                              Q.{parseInt(this.props.params.offset) + 1}
                            </div>
                            {renderHTMLContent(
                              selectedQuestionData.question,
                              "div",
                              "qus-title w-100",
                              { contentEditable: false, style: { marginTop: "8px" } }
                            )}
                          </div>
                        ) : null}
                        <span className='tooltip_wrap'>
                          <button
                            className='btn btn-primary pointer_class mid-btn'
                            onClick={() => {
                              this.setState({
                                showSectionReview: true,
                              });
                              this.getReadingViseScore();
                            }}
                          >
                            {language.LC().SCORE}
                          </button>
                          <div className='tootip_box'>{language.LC().SHOW_MYSCORE_Book}</div>
                        </span>

                        <span className='tooltip_wrap tooltip_wrap_margin'>
                          <button
                            disabled={
                              rightanswercount ? (rightanswercount === 0 ? true : false) : true
                            }
                            className={
                              rightanswercount === 0
                                ? 'cursor_not_Allowed btn btn-primary  mid-btn'
                                : 'btn btn-primary mid-btn'
                            }
                            onClick={() => this.getDetailedResultGraph(totalAvailableQuestions)}
                          >
                            {language.LC().GRAPH}
                          </button>
                          {rightanswercount ? (
                            rightanswercount === 0 ? null : (
                              <div className='tootip_box'>{language.LC().SHOW_GRAPH}</div>
                            )
                          ) : null}
                          { }
                        </span>
                      </div>
                      <div className='card-block'>
                        <div className='row'>
                          <div className='col-sm-8 col-lg-9'>
                            <div className='row'>
                              {frmOptionsArr.map((item, index) => {
                                return (
                                  <div className='col-sm-12' id={item} key={index}>
                                    <div
                                      className={`answer_box cursor-default ${userChoice
                                        ? selectedQuestionData &&
                                          selectedQuestionData.answer === item &&
                                          userChoice[this.props.params.questiono] === item
                                          ? `border-green`
                                          : selectedQuestionData.answer === item
                                            ? 'border-green'
                                            : userChoice[this.props.params.questiono] === item
                                              ? 'border-red'
                                              : ''
                                        : ''
                                        }`}
                                    >
                                      <div className='answer_count highlight_choice'>
                                        {item === 'choice_a'
                                          ? language.LC().A
                                          : item === 'choice_b'
                                            ? language.LC().B
                                            : item === 'choice_c'
                                              ? language.LC().C
                                              : language.LC().D}
                                      </div>
                                      <p className={`ans_box_text`}>
                                        {selectedQuestionData && selectedQuestionData[item] ? (
                                          renderHTMLContent(
                                            selectedQuestionData[item],
                                            "span",
                                            "",
                                            { contentEditable: false }
                                          )
                                        ) : null}
                                      </p>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                          <div className='col-sm-4 col-lg-3'>
                            <div className='score-wrapper'>
                              <div className='score-inner'>
                                {rightanswercount ? rightanswercount : 0}/{totalAvailableQuestions}
                              </div>
                              <h5>{language.LC().TOTAL_SCORE}</h5>
                              <h5>
                                {language.LC().You_Scored} {Math.ceil(percentage)}%
                              </h5>
                            </div>
                            <div className='timer_outer finished-time'>
                              <div>
                                <h4>{language.LC().TEST_COMPLETED_IN}</h4>
                                <i className='fa fa-clock-o' />
                                <span className='timer_box'>{userTime}</span>
                              </div>
                            </div>
                          </div>

                          <div className='col-lg-12'>
                            <div className='text-right btm-btn-wrapper'>
                              <span
                                className='up tooltip-hover-questions'
                                style={{ padding: '10px' }}
                              >
                                <div className='tootip_box'>
                                  {' '}
                                  {language.LC().REPORT_THIS_QUESTION}{' '}
                                </div>
                                <div
                                  className='report-icon-wrapper'
                                  onClick={() => {
                                    this.handleScroll();
                                    this.setState({
                                      report_block: 'card show_block',
                                    });
                                  }}
                                >
                                  <img
                                    src={App_data.frontend_url + '/img/report4.png'}
                                    alt='report'
                                  />
                                </div>
                              </span>
                              <Button
                                onClick={() => this.getPrevious(this.props.params.offset)}
                                className='pointer_class btn-primary'
                                disabled={parseInt(this.props.params.offset) === 0}
                              >
                                <i className='fa fa-angle-left' /> {language.LC().BACK}
                              </Button>

                              <Button
                                onClick={() => this.getNext(this.props.params.offset)}
                                className='pointer_class btn-primary'
                                disabled={
                                  parseInt(this.props.params.offset) === questionsData.length - 1
                                }
                              >
                                {language.LC().NEXT} <i className='fa fa-angle-right' />
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className='card show_block'>
                <div
                  className={`card-header  ${userChoice &&
                    userChoice[this.props.params.questiono] === selectedQuestionData.answer
                    ? 'text_success-cbt'
                    : !userChoice[this.props.params.questiono]
                      ? 'text_unAttempted-cbt'
                      : 'text_failure-cbt'
                    }`}
                >
                  {userChoice &&
                    userChoice[this.props.params.questiono] === selectedQuestionData.answer
                    ? `${language.LC().Correct}`
                    : !userChoice[this.props.params.questiono]
                      ? `${language.LC().NOT_ATTEMPTED}`
                      : `${language.LC().Incorrect}`}
                </div>

                <div className='card-block'>
                  {selectedQuestionData && selectedQuestionData.explanation
                    ? renderHTMLContent(
                      selectedQuestionData.explanation,
                      "p",
                      "view_questionhtml",
                      { contentEditable: false }
                    )
                    : ""}
                </div>
              </div>
              <div className='row'>
                <div className='col-md-12'>
                  <div className={this.state.report_block}>
                    <div className='card-header'>{language.LC().REPORT}</div>
                    {!this.state.successAlert ? (
                      <div className='card-block'>
                        <div className='row'>
                          <div className='col-xs-12 col-sm-12 col-md-12'>
                            <label className='form-control-label' htmlFor='textarea-input'>
                              <strong>{language.LC().COMMENT}</strong>
                            </label>
                          </div>
                          <div className='col-xs-12 col-sm-12 col-md-12 margin_bottom_10'>
                            <textarea
                              id='comment'
                              name='comment'
                              rows='6'
                              className='form-control'
                              placeholder='Content..'
                            />
                          </div>
                        </div>
                        <div className='row'>
                          <div className='col-xs-12 col-sm-12 col-md-12'>
                            <button
                              type='button'
                              className='btn btn-primary active pointer_class report-btn'
                              disabled={reportLoading}
                              onClick={() => this.reportQuestion(selectedQuestionData.id)}
                            >
                              {reportLoading ? (
                                <span>
                                  <i className='fa fa-spinner fa-spin' />{' '}
                                  {language.LC().PLEASE_WAIT}
                                </span>
                              ) : (
                                language.LC().REPORT
                              )}
                            </button>
                            <button
                              type='button'
                              className='btn btn-danger active pointer_class margin_left_10'
                              onClick={this._hideReportForm.bind(this)}
                            >
                              {language.LC().CANCEL}
                            </button>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className='card-block'>
                        <div className='row'>
                          <div className='col-sm-12 report-Success-card'>
                            <img src={App_data.frontend_url + '/img/success-ic.svg'} alt='' />
                            <label className='form-control-label' htmlFor='textarea-input'>
                              <strong> {language.LC().REPORT_SEND_SUCCESS_MESSAGE}</strong>
                            </label>
                            <button
                              type='button'
                              className='btn btn-primary active pointer_class  min-vw-120'
                              onClick={this.onClose}
                            >
                              {' '}
                              {language.LC().CLOSE}
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className='no-qus-found'>
              <img width='105px' src={App_data.frontend_url + '/img/questions/problem.png'} />
              <h3>{language.LC().NO_QUESTION_FOUND}</h3>
              <p> {language.LC().NO_QUESTION_FOR_THIS_EXAM}</p>
            </div>
          )}
        </div>
        {/* =========For Side Bar S============ */}
        <div
          className={`sidebar-review-wrapper sidebar-score-wrapper ${showSectionReview ? 'active' : ''
            }`}
        >
          <div className='header-review'>
            <h2> {language.LC().BOOK_WISE_SCORE}</h2>
            <span
              className='cursor-pointer'
              onClick={() => {
                this.setState({
                  showSectionReview: false,
                });
              }}
            >
              <img width='30px' src={App_data.frontend_url + '/img/questions/icon_close.png'} />
            </span>
          </div>
          <div className='body-review'>
            <ul className='score-list-wrapper'>
              {readingViseScore && readingViseScore.length ? (
                readingViseScore.map((item, index) => {
                  let readingPercentage =
                    (item.question_count * 100) / item.frm_cbt_questions.length || 0;
                  return (
                    <li key={index}>
                      <div>
                        <h4>
                          {index + 1}&nbsp; {item.chapter_name}
                        </h4>
                        <div className='progress custom-prog-bar margin_top_5'>
                          <div
                            className='progress-bar'
                            role='progressbar'
                            style={{
                              width: `${readingPercentage ? Math.ceil(readingPercentage) : '0'}%`,
                            }}
                            aria-valuenow={`${readingPercentage ? Math.ceil(readingPercentage) : '0'
                              }%`}
                            aria-valuemin='0%'
                            aria-valuemax='100%'
                          >
                            {readingPercentage ? Math.ceil(readingPercentage) : '0'}%
                          </div>
                        </div>
                      </div>
                      <p className='score-inner'>
                        {item.question_count ? item.question_count : 0}/
                        {item.frm_cbt_questions ? item.frm_cbt_questions.length : 0}
                      </p>
                    </li>
                  );
                })
              ) : (
                <div className='no-qus-found no-mock-exam mt-5'>
                  <img
                    width='62px'
                    src={App_data.frontend_url + '/img/questions/icon_nomock.png'}
                  />
                  <h3 className='mt-1'>{language.LC().NO_SCORE_FOUND}</h3>
                </div>
              )}
            </ul>
          </div>
        </div>
        {/* =========For Side Bar E============ */}
      </div>
    );
  }
}

export default CFAQuestions;



// WEBPACK FOOTER //
// ./src/views/CBT/FRMCBT/FinishTest/index.js